import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./EmailVerifyOTP.css";
import { New_ScrollX2025 } from "../../assets/icons";

const EmailVerifyOTP = (props) => {
    const {
        isSignUpSuccess,
        setIsSignUpSuccess,
        otp,
        setOpt,
        handleSubmitOtp,
        inValidOtp,
        setInValidOtp,
        handleResendOtp,
        email: emailProp,
    } = props;
    const OTP_LENGTH = 6;

    const [newUserEmail, setnewUserEmail] = useState("");
    // console.log('newUserEmail = ', newUserEmail);

    useEffect(() => {
        try {
            const stored =
                emailProp ||
                JSON.parse(
                    localStorage.getItem("user") ||
                        localStorage.getItem("dup-user") ||
                        "{}",
                )?.email ||
                "";
            if (!stored.includes("@")) {
                setnewUserEmail("");
                return;
            }
            const [name, domain] = stored.split("@");
            setnewUserEmail(
                name.length <= 2 ? `${name}@${domain}` : `${name[0]}${"*".repeat(name.length - 2)}${name.slice(-1)}@${domain}`
            );
        } catch (error) {
            console.error("Failed to read user data:", error);
            setnewUserEmail("");
        }
    }, [emailProp]);

    // Ensure OTP is always an array of 6 characters
    const otpArray = otp ? otp.split("").concat(Array(6 - otp.length).fill("")) : Array(6).fill("");
    // const otpArray = (otp || "").slice(0, OTP_LENGTH).padEnd(OTP_LENGTH, "").split("");

    // Handle OTP change
    const handleChange = (e, index) => {
        const value = e.target.value.replace(/\D/g, ""); // Allow only numbers

        const newOtp = [...otpArray]; // Clone OTP array
        if (!value) {
            newOtp[index] = "";
            setOpt(newOtp.join(""));
            return;
        }

        value.split("").forEach((digit, i) => {
            if (index + i < OTP_LENGTH) {
                newOtp[index + i] = digit;
            }
        });

        setOpt(newOtp.join(""));

        const nextIndex = Math.min(
            index + value.length,
            OTP_LENGTH - 1
        );

        document.getElementById(`otp-${nextIndex}`)?.focus();
    };

    // Handle backspace
    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newOtp = [...otpArray];

            if (newOtp[index]) {
                newOtp[index] = ""; // Clear current input
                setOpt(newOtp.join("")); // Update state
                return;
            }

            if (index > 0) {
                newOtp[index - 1] = "";
                setOpt(newOtp.join(""));
                document.getElementById(`otp-${index - 1}`)?.focus();
            }
        }

        if (e.key === "ArrowLeft" && index > 0) {
            document.getElementById(`otp-${index - 1}`)?.focus();
        }

        if (e.key === "ArrowRight" && index < OTP_LENGTH - 1) {
            document.getElementById(`otp-${index + 1}`)?.focus();
        }
    };
 
    // Handle Paste    
    const handlePaste = (e, index = 0) => {
        e.preventDefault();

        const pasted = e.clipboardData
            .getData("text")
            .replace(/\D/g, "")
            .slice(0, OTP_LENGTH - index);

        if (!pasted) return;

        const currentOtp = [...otpArray];

        pasted.split("").forEach((digit, i) => {
            currentOtp[index + i] = digit;
        });

        setOpt(currentOtp.join(""));

        const focusIndex = Math.min(
            index + pasted.length,
            OTP_LENGTH - 1
        );

        document.getElementById(`otp-${focusIndex}`)?.focus();
    };

    return (
        <>
            <div className="EmailVerifyOTP-Container bg-[#06050c]">

                <div className="EmailVerifyOTP-particles"></div>

                <header className="topbar">
                    <nav className="w-full flex justify-between vorp-nav">
                        <a href="#" className="nav-logo">
                            <span className="nav-logo-icon"><img className="logo-img999 " src={New_ScrollX2025} alt="icon" /></span>
                            <span>ScrollX</span>
                        </a>
                    </nav>
                </header>

                <main className="mainContainer-fullPage">

                    <div className="content-box">

                        <p className="eyebrow">Verify email</p>

                        <h1 className="heading">Check your inbox</h1>

                        <p className="sub"> We sent a 6-digit code to {" "} 
                            <strong>{newUserEmail}</strong>. Enter it below to verify 
                            your account.
                        </p>

                    <div className="otp-card">

                        <p className="otp-label">One-time code</p>

                        <div className="otp-row" id="otpRow">

                            {otpArray.map((digit, index) => (
                                <input
                                    className="otp-box"
                                    type="text"
                                    key={index}
                                    id={`otp-${index}`}
                                    maxLength="1"  
                                    value={digit}
                                    onChange={(e) => handleChange(e, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    onPaste={(e) => handlePaste(e, index)}
                                    placeholder=""                                    
                                    autoComplete="one-time-code"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    aria-label={`Digit ${index + 1}`}
                                />

                            ))}
                        </div>

                        {/* Invalid OTP Message */}
                        {inValidOtp && (<p className="text-red-500 mt-2">{inValidOtp}</p>)}

                        <div className="btn-row">
                            <button className="btn-resend" id="resendBtn" type="button"  onClick={handleResendOtp}>Resend code</button>
                            <button className="btn-verify" id="verifyBtn" type="button" onClick={handleSubmitOtp}disabled={otp.length !== OTP_LENGTH}>Verify Email <span className="arrow">→</span></button>
                        </div>

                        <div className="success-msg" id="successMsg">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                            Email verified. Redirecting you to your dashboard…
                        </div>

                    </div>

                    <p className="resend-hint" id="resendHint">Didn't receive it? Check your spam, or{" "}<span href="#"> send it again </span>.</p>
                    </div>
                </main>

            </div>
        </>

    );
};

export default EmailVerifyOTP;